  // Generate a range of valid years, e.g. current year + next 10 years
  const currentYear = new Date().getFullYear();
  export const yearOptions = Array.from({ length: 11 }, (_, i) =>
    (currentYear + i).toString()
  );


  export const hardcodedMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];